import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    powerInKw: 5,
    kSpringOne: 3,
    presetSpringOne: 30,
    kSpringTwo: 2,
    positionSpringTwo: 60,
    showIdealCurve: true, 
    showSpringCurve: false,
    doubleSpring: false,
};

export const drawingBoardSlice = createSlice({
    name: 'drawingBoard',
    initialState,
    reducers: {
        setPower: (state, action) => {
            state.powerInKw = action.payload;
        },
        setKSpringOne: (state, action) => {
            state.kSpringOne = action.payload;
        },
        setPresetSpringOne: (state, action) => {
            state.presetSpringOne = action.payload;
        },
        setKSpringTwo: (state, action) => {
            state.kSpringTwo = action.payload;
        },
        setPositionSpringTwo: (state, action) => {
            state.positionSpringTwo = action.payload;
        },
        toggleIdealCurve: (state) => {
            state.showIdealCurve = !state.showIdealCurve;
        },
        toggleSpringCurve: (state) => {
            state.showSpringCurve = !state.showSpringCurve;
        },
        toggleDoubleSpring: (state) => {
            state.doubleSpring = !state.doubleSpring;
        },
    }
});

export const { 
    setPower,
    setKSpringOne,
    setPresetSpringOne,
    setKSpringTwo,
    setPositionSpringTwo,
    toggleIdealCurve,
    toggleSpringCurve,
    toggleDoubleSpring,
 } = drawingBoardSlice.actions;

export const selectPower = (state) => state.drawingBoard.powerInKw;
export const selectKSpringOne = (state) => state.drawingBoard.kSpringOne;
export const selectPresetSpringOne = (state) => state.drawingBoard.presetSpringOne;
export const selectKSpringTwo = (state) => state.drawingBoard.kSpringTwo;
export const selectPositionSpringTwo = (state) => state.drawingBoard.positionSpringTwo;
export const selectShowIdealCurve = (state) => state.drawingBoard.showIdealCurve;
export const selectShowSpringCurve = (state) => state.drawingBoard.showSpringCurve;
export const selectDoubleSpring = (state) => state.drawingBoard.doubleSpring;

export default drawingBoardSlice.reducer;
